import ModuleView from "@/components/shieldx/ModuleView";
import { FileLock2 } from "lucide-react";
export default function AuditVault() {
  return <ModuleView name="audit-vault" icon={FileLock2} />;
}
